import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Screening, ScreeningInvite, ScreeningLight, ObjectUpdatePayload, ScreeningNote, ScreeningAdditionalData, ApplicantDocument, ScreeningDupeCheckModel, EndUserCertification, AdverseActionLetterStats, GroupPMScoreRecord, ProcessorReportOpenBreadCrumb } from '../../models/screeningInvite';
import { ScreeningFilter, ScreeningOrderByContract, ScreeningFilteredListRequestModels, OrderByDesignator, StandAloneFilter, SearchAndPipeFilter } from '../../models/ScreeningFilter';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { ClientService } from '../../clients-module/services/client.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { DataFilter, DataFilterTypes } from '../../models/dataFilter';
import { FilteringService } from '../../services/filtering.service';
import { SimpleDataFilter } from '../../models/simpleDataFilter';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { ClientLocation } from 'src/app/clients-module/models/clientLocation';
import {PaginationService} from '../../shared-components-module/pagination-top/services/pagination.service';
import { EmployerVerificationData, ReferenceVerificationData } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { FileTransferPayload } from 'src/app/models/FileTransferPayload';
import { Router } from '@angular/router';
import { ScreeningChangeLogs } from 'src/app/shared-components-module/change-log/change-log.component';
import { ReviewRequiredReason } from 'src/app/models/hardDeclineReason';
import { FullFileDisclosureIdentity } from '../models/FullFileDisclosureIdentity';
import { ApplicantIdentity } from 'src/app/models/applicantIdentity';

@Injectable({
  providedIn: 'root'
})
export class ScreeningService {

  loading :boolean = false;
  clientLocation: number;
  screeningToken: string;
  screeningType: string;
  userId: number;
  activeTag: number | null;
  screenings: Array<ScreeningLight> = [];
  screeningFilter: ScreeningFilter = new ScreeningFilter();
  standAloneFilter: StandAloneFilter = new StandAloneFilter();
  orderBy : ScreeningOrderByContract = new ScreeningOrderByContract();
  storeFilter: boolean = false;
  screeningsLoaded: Subject<boolean> = new Subject<boolean>();
  thresholdDetermined : Subject<string> = new Subject<string>();
  screeningsLoading : boolean = true;
  totalScreeningCount : number;
  paginationOverride : number;
  quickFilterApplied: boolean;
  constructor(public http: HttpClient,
    public toast: ToastrService,
    private auth: AuthService,
    private clientLoc: PropertyService,
    private readonly paginationService: PaginationService,
    public filters : FilteringService) {
    this.auth.logoutComplete.subscribe(ev =>{
        this.screenings = [];
    })
  }

  /// RIQ-3112: animations for socket updates.
  public pulsingText = {
    //pulsing: false,
    residentIQ : false,
    reportStatus : false,
    searchUpdate : false
  }

  SaveInvitation(invite: ScreeningInvite) {
    return this.http.post(environment.baseURl + '/api/screening/invite/save', invite);
  }

  releaseTntReportResults(screeningId: number) {
    return this.http.get(`${environment.baseURl}/api/partner/release/${screeningId}`,{ responseType: 'text' });
  }


  FetchScreeningsForClient(clientId: number,take :number) {
    this.loading = true;
    this.http.get<Array<ScreeningLight>>(environment.baseURl + `/api/screening/list/${clientId}/${take}`).subscribe(
      (dta: any) => {
        this.screenings = dta.map(s =>{
          return Object.assign(new ScreeningLight(), s);
        });
        this.screeningsLoaded.next(true);
        this.loading = false;
      },
      (err: any) => {
        this.toast.error('There was an error loading your screening widget. If the issue persists please contact support.', 'Error Fetching your Screenings', { disableTimeOut: true, closeButton: true })
      }
    );
  }

  FetchFilteredScreeningsList(fetch: number = undefined,offset : number = undefined) {
    this.loading = true;
    this.screenings = [];
    var rqst = new ScreeningFilteredListRequestModels();
    rqst.filters = this.screeningFilter;
    rqst.orderBy = this.orderBy;

    var offset2 = (this.paginationService.currentPage -1) * this.paginationService.pageIncrement;
    var url = environment.baseURl + `/api/screening/list/${fetch ?? this.paginationService.pageIncrement}/${offset ?? offset2}`;

    this.http.post<Array<ScreeningLight>>(url, rqst).subscribe(
      (dta: any) => {
        if(!dta) this.loading = false;
        // this.screenings = dta.listResult;
        this.screenings = dta.listResult.map(s =>{
          return Object.assign(new ScreeningLight(), s);
        });

        this.screeningsLoaded.next(true);
        this.loading = false;
        this.totalScreeningCount = dta.totalRecordsCount;
      },
      (err: any) => {
        if(this.auth.isAuthenticated) this.toast.error('There was an error loading your screening widget. If the issue persists please contact support.', 'Error Fetching your Screenings', { disableTimeOut: true, closeButton: true });
      }
    );
  }

  FetchScreeningsForProcessingList(offset : number, fetchCount : number){
    this.loading = true;
    this.screenings = [];
    var rqst = new ScreeningFilteredListRequestModels();
    rqst.filters = this.screeningFilter;
    rqst.orderBy = this.orderBy;

    this.paginationOverride = undefined;
    this.http.post<any>(environment.baseURl + `/api/screening/list/processing/${offset}/${fetchCount}`,rqst).subscribe(
      (dta: any) => {
        this.screenings = dta.listResult;
        this.screeningsLoaded.next(true);
        this.loading = false;
        this.totalScreeningCount = dta.totalRecordsCount;
      },
      (err: any) => {
        this.toast.error('There was an error loading your screening widget. If the issue persists please contact support.', 'Error Fetching your Screenings', { disableTimeOut: true, closeButton: true })
      }
    );
  }

  FetchByStandaloneForProcessingList(offset : number, fetchCount : number){
    this.loading = true;
    this.screenings = [];

    this.paginationOverride = undefined;
    this.standAloneFilter.searchDepth
    this.http.post<any>(environment.baseURl + `/api/screening/list/processing/standalone/${offset}/${fetchCount}`, { notRunSearch : this.standAloneFilter.searchType, crimType : this.standAloneFilter.searchDepth} ).subscribe(
      (dta: any) => {
        this.screenings = dta.listResult;
        this.screeningsLoaded.next(true);
        this.loading = false;
        this.totalScreeningCount = dta.totalRecordsCount;
      },
      (err: any) => {
        this.toast.error('There was an error loading your screening widget. If the issue persists please contact support.', 'Error Fetching your Screenings', { disableTimeOut: true, closeButton: true })
      }
    );
  }

  FetchBySearchAndPipeStageForProcessingList(offset: number, fetchCount : number, pipeStage: number, searchType: number) {
    let filt: SearchAndPipeFilter = new SearchAndPipeFilter();
    filt.pipelineStage = pipeStage;
    filt.searchType = searchType;
    this.http.post<any>(environment.baseURl + `/api/screening/list/processing/bypipe/${offset}/${fetchCount}`, filt).subscribe(
      (dta: any) => {
        this.screenings = dta.listResult;
        this.screeningsLoaded.next(true);
        this.loading = false;
        this.totalScreeningCount = dta.totalRecordsCount;
      },
      (err: any) => {
        this.toast.error('There was an error loading your screening widget. If the issue persists please contact support.', 'Error Fetching your Screenings', { disableTimeOut: true, closeButton: true })
      }
    );

  }

  /** RIQ-5132 / RIQ-5150: IDs of screenings with Income Verification tag (tag 9) that have Argyle income received. One GET returns full list for all pages. */
  getIncomeVerificationTaggedIds(): Observable<number[]> {
    return this.http.get<number[]>(environment.baseURl + '/api/screening/income-verification-tagged-ids');
  }

  FetchScreeningsForTag(tagId : number){
    this.http.get<ScreeningLight>(environment.baseURl + `/api/screening/list/${tagId}`).subscribe(
      (dta: any) => {
        this.screenings = dta.listResult;
        this.screeningsLoaded.next(true);
        this.loading = false;
        this.totalScreeningCount = dta.totalRecordsCount;
        this.paginationOverride = dta.totalRecordsCount;
        this.quickFilterApplied = true;
      },
      (err: any) => {
        this.toast.error('There was an error loading your screening widget. If the issue persists please contact support.', 'Error Fetching your Screenings', { disableTimeOut: true, closeButton: true })
      }
    );
  }

  formatPhoneNumber(phoneNumber : string) {
    var cleaned = ('' + phoneNumber).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '')
      return [match[1],match[2], match[3],match[4]].join('')
    }
}

  FetchScreening(token: string) {
    return this.http.get<ScreeningLight>(environment.baseURl + `/api/screening/light/${token}`);
  }

  FetchScreeningById(id: number) {
    return this.http.get<ScreeningLight>(environment.baseURl + `/api/screening/light/${id}`);
  }
  // Get Review Require Reasons

  FetchReviewRequiredReasons(){
    return this.http.get<Array<ReviewRequiredReason>>(environment.baseURl + `/api/reportData/rr-reasons`);
  }

  // Get RRRs for this screening specifically
  FetchReviewRequiredReasonsScrn(scrn : number){
    return this.http.get<Array<ReviewRequiredReason>>(environment.baseURl + `/api/reportData/rr-reasons/${scrn}`);
  }

  ActivateReport(rpt : number, scrn: number, usr: number, usrN: string){
    let crm = new ProcessorReportOpenBreadCrumb();
    crm.reportNumber = rpt;
    crm.screeningId = scrn;
    crm.userId = usr;
    crm.userName = usrN;

    
    return this.http.post(environment.baseURl + `/api/lookingglass/report/active`,crm);
  }

  AbandonReport(crmb : ProcessorReportOpenBreadCrumb){    
    return this.http.post(environment.baseURl + `/api/lookingglass/report/deactive`,crmb);
  }


  // Add RRR 
  AddReviewRequiredReasonsScrn(scrn : number, rpt : number, rrId : number){
    return this.http.post(environment.baseURl + `/api/reportData/rr-reasons`, {scrn, rpt, rrId});
  }
  // Remove RRR
  RemoveReviewRequiredReasonsScrn(scrn : number, rrId : number){
    return this.http.post(environment.baseURl + `/api/reportData/rr-reasons/remove`, {scrn, rrId});
  }

  FetchSupportingDocsSummary(screeningId : number) {
    return this.http.get<ApplicantDocument[]>(environment.baseURl + `/api/screening/document/summary/${screeningId}`);
  }

  FetchScreeningAdditionalData(id: number) {
    return this.http.get<ScreeningAdditionalData[]>(environment.baseURl + `/api/screening/light/additionaldata/${id}`);
  }

  GenerateAdverseActionLetter(orderId : number) {
    return this.http.get(environment.baseURl + `/api/screening/adverse-action/${orderId}`);
  }

  FetchTopNScreenings() {
    this.loading = true;
    this.http.get<Array<ScreeningLight>>(environment.baseURl + `/api/screening/list/dashboard`).subscribe(
      (dta: Array<ScreeningLight>) => {
        this.screenings = [];
        dta.forEach(s =>{
          this.screenings.push(Object.assign(new ScreeningLight(),s));
        })
        this.loading = false;
      },
      (err: any) => {
        this.toast.error('There was an error loading your screening widget. If the issue persists please contact support.', 'Error Fetching your Screenings', { disableTimeOut: true, closeButton: true })
      }
    );
  }

  GetScreening(token: string): Observable<Screening> {
    return this.http.get<Screening>(environment.baseURl + `/api/screening/screening/${token}`)
  }

  GetScreeningById(id: number, init : boolean = false): Observable<Screening> {
    return this.http.get<Screening>(environment.baseURl + `/api/screening/screening/${id}/${init}`)
  }

  RerunSearch(token: number): Observable<boolean> {
    return this.http.get<boolean>(environment.baseURl + `/api/screening/rerun/${token}`)
  }

  RefilterSearch(searchEntryId: number): Observable<boolean> {
    return this.http.get<boolean>(environment.baseURl + `/api/screening/refilter/${searchEntryId}`)
  }

  VoidScreeningBillingEntry(aseId: number): Observable<boolean> {
    return this.http.get<boolean>(environment.baseURl + `/api/screening/void/${aseId}`)
  }

  CancelScreening(inviteId: number): Observable<boolean> {
    return this.http.get<boolean>(environment.baseURl + `/api/screening/cancel/${inviteId}`)
  }

  SaveScreening(model : any): Observable<any> {
    return this.http.post(environment.baseURl + `/api/screening`, model);
  }

  UpdateScreeningPIT(model : Screening): Observable<any> {
    return this.http.post(environment.baseURl + `/api/screening/update2`, model);
  }

  UpdateScreeningLightPIT(model : ScreeningLight): Observable<any> {
    return this.http.post(environment.baseURl + `/api/screening/update3`, model);
  }

  UpdateScreeningInvitePIT(model: ScreeningInvite): Observable<any> {
    return this.http.post(environment.baseURl + '/api/screening/invite/update', model);
  }

  CancelSearch(screeningId : number, searchType : string) : Observable<boolean> {
    return this.http.get<boolean>(environment.baseURl + `/api/screening/cancel/search/${screeningId}/${searchType}`);
  }

  GetReportViewToken(screeningId : number) {
    return this.http.get(environment.baseURl + `/api/screening/report/request/${screeningId}`);
  }

 
  public SaveNewScreeningNote(note : ScreeningNote) {
    return this.http.post(environment.baseURl + `/api/screening/note/save`, note);
  }

  public UpdateScreeningNote(note : ScreeningNote) {
    return this.http.post(environment.baseURl + `/api/screening/note/update`, note);
  }

  public HideScreeningNote(note : ScreeningNote) {
    return this.http.get(environment.baseURl + `/api/screening/note/hide/${note.id}`);
  }

  GetScreeningInvite(token : string) {
    return this.http.get(environment.baseURl + `/api/screening/invite/fetch/${token}`);
  }

  GetScreeningPITLogs(screeningId : number, rptnmbr : number){
    return this.http.get(environment.riqAzureFuncUrl + `/api/GetSCreeningUpdates?code=${environment.riqAzureFuncToken}&scr=${screeningId}&inv=${rptnmbr}`);
  }

  GetGroupScoreForToken(tkn : string){
    return this.http.get<GroupPMScoreRecord>(environment.baseURl + `/api/applicantdata/group-score/${tkn}`);
  }

  /** Note, this can return a null instead of a date time and should be handled per the criteria on the ticket, see RIQ-2064  */
  public FetchCrimSearchETA(screeningId: number) {
    return this.http.get<Date>(environment.baseURl + `/api/applicantdata/criminal/eta/` + screeningId);
  }

  public validateDateFilter(d : moment.Moment) : boolean {
    //the standard NaN check is failing here?? but converting to string works for this eval
    if(d.date().toString() == 'NaN') return false;
    if(d.month().toString() == 'NaN') return false;
    if(d.year().toString() == 'NaN') return false;
    return true;
}

public formatSSN(val: string): string {
  val = val.replace(/[^0-9]*/g, '').replace(/-/g, '').replace(/ /g, '');
  const len = val.length;
  if (len <= 3) {
    return val;
  }
  else if (len >= 4 && len <= 5) {
    return `${val.substr(0, 3)}-${val.substr(3, 2)}`;
  }
    else if (len >= 6 && len <= 9) {
      return `${val.substr(0, 3)}-${val.substr(3, 2)}-${val.substr(5, len)}`;
  }
    else { return 'Invalid SSN'; }
}

  SendAdverseActionLetter(orderId : number) {
    return this.http.get(environment.baseURl + `/api/screening/adverse-action/send/${orderId}`);
  }

  UploadSupportingDoc(ftp : FileTransferPayload) {
    return this.http.post(environment.baseURl + `/api/screening/document/supporting`, ftp)
  }

  ScreeningDupeCheck(dupe : ScreeningDupeCheckModel) {
    return this.http.post(environment.baseURl + `/api/screening/dupecheck`, dupe);
  }

  SaveEndUserCert(cert : EndUserCertification) {
    return this.http.post(environment.baseURl + `/api/screeningdraft/electronic-consent`, cert);
  }

  DownloadArchivedAAL(fileId : number) {
    return this.http.get(environment.baseURl + `/api/screening/adverse-action/fetch/${fileId}`, { responseType: 'blob' });
  }

  DownloadSupportingDoc(fileId : number) {
    return this.http.get(environment.baseURl + `/api/screening/document/fetch/${fileId}`, { responseType: 'blob' });
  }

  DownloadRawVendorData(srsID : number) :Observable<Blob> {
    return this.http.get(environment.baseURl + `/api/values/srs/${srsID}`, { responseType: 'blob' });
  }

  SaveScreeningPITLog(scrn: Screening){
    this.http.post(environment.baseURl + `/api/pitlogging/screening/update/`,scrn).subscribe((evt: any)=>{
      if(!evt.logSaved){
        console.warn('failed to save PIT log',scrn);
      }
    })
  }

  FetchAALStatsLogs(orderId: number) {
    return this.http.get<AdverseActionLetterStats[]>(environment.baseURl + '/api/screening/adverse-action/stats/' + orderId);
  }

  GetScreeningChangeLogs(reportNumber: number) : Observable<ScreeningChangeLogs>{
    return this.http.get<ScreeningChangeLogs>(environment.baseURl + `/api/changelog/logs/${reportNumber}`);
  }

  GetApplicantCountyFromAddressParts(street : string, city : string, state : string){
    return this.http.post(environment.baseURl + `/api/geocode/county`, {street,city,state});
  }

  GetFFDIdentity(screeningId: number) {
    return this.http.get(environment.baseURl + '/api/screening/ffd/'+screeningId);
  }


  CreateFFDIdentity(scrn: ScreeningLight) {
    let ffd: FullFileDisclosureIdentity = new FullFileDisclosureIdentity();
    ffd.SocialSecurityNumber = scrn.applicantSSN;
    ffd.ScreeningId = scrn.id;
    ffd.FirstName = scrn.applicantFirstName;
    ffd.LastName = scrn.applicantLastName;
    ffd.DateOfBirth = scrn.applicantDOB;

    return this.http.post(environment.baseURl + '/api/screening/ffd', ffd);
  }

  WriteLogToRIQ(log: any){
    this.http.post(environment.baseURl + `/api/values/write/log`,log).subscribe();
  }

  getSearches(id : number) {
    return this.http.get(environment.baseURl + `/api/values/search-states/${id}`);
  }


  formatAsUTCLocal(date: Date, showTime: boolean): string {
    if(date == undefined || date == null) return null;
    var m = moment.utc(date);
    if (!m.isValid()) return null;
    if (showTime) return m.local().format('M/D/YYYY h:mm A')
    return m.local().format('M/D/YYYY');
  }

  public propertyDecisions: Array<any> = [
    "Accept",
    "Conditional-High",
    "Conditional-Low",
    "Decline",
    "Review Required",
    null
  ]

  // RIQ-4642: Check for sibling screening reports within the last 60 days (OLD METHOD - for backward compatibility)
  public checkSiblingScreening(identity: ApplicantIdentity, currentScreeningId: number): Observable<ScreeningLight> {
    return this.http.post<ScreeningLight>(`${environment.baseURl}/api/screening/sibling/${currentScreeningId}`, identity);
  }

  // RIQ-4642: Get ALL sibling screenings from optimized stats table (NEW OPTIMIZED METHOD)
  public getSiblingScreenings(currentScreeningId: number): Observable<ScreeningLight[]> {
    return this.http.get<ScreeningLight[]>(`${environment.baseURl}/api/screening/siblings/${currentScreeningId}`);
  }

}
